import { GROUPS, KanbanContractError, formatDate, validCard } from './contract';

export const TRAVEL_GROUPS = GROUPS.filter(({ code }) => code !== 'AVAILABLE');
const count = (value) => Number.isSafeInteger(value) && value >= 0;
const nullableText = (value) => value === null || typeof value === 'string';
const nullableDate = (value) => value === null || formatDate(value) !== 'Não informado';
const coordinate = (value, limit) => Number.isFinite(value) && Math.abs(value) <= limit;

function validPosition(position) {
  if (position === null) return true;
  return !!(
    position &&
    (position.source === 'TRAVEL_LOCATION'
      ? count(position.id) && position.id > 0
      : position.source === 'TRAVEL_SNAPSHOT' && position.id === null) &&
    ((position.latitude === null && position.longitude === null) ||
      (coordinate(position.latitude, 90) && coordinate(position.longitude, 180))) &&
    nullableText(position.information) &&
    nullableText(position.description) &&
    nullableDate(position.capturedAt)
  );
}

/** Valida a página global sem reclassificar status ou juntar páginas do Kanban. */
export function validateOpenTravels(data, requested) {
  const fail = () => {
    throw new KanbanContractError(
      'Resposta inválida da lista de viagens. Tente atualizar a consulta.',
    );
  };
  if (
    data?.version !== 1 ||
    data.timezone !== 'America/Sao_Paulo' ||
    formatDate(data.asOf) === 'Não informado' ||
    !count(data.totalCount) ||
    !Array.isArray(data.groups) ||
    data.groups.length !== TRAVEL_GROUPS.length ||
    !Array.isArray(data.data)
  )
    fail();
  const totals = new Map();
  data.groups.forEach((group) => {
    if (
      !group ||
      !TRAVEL_GROUPS.some(({ code }) => code === group.code) ||
      totals.has(group.code) ||
      !count(group.totalCount)
    )
      fail();
    totals.set(group.code, group.totalCount);
  });
  if ([...totals.values()].reduce((sum, value) => sum + value, 0) !== data.totalCount) fail();
  const { page, perPage } = requested;
  const offset = (page - 1) * perPage;
  const pagination = data.pagination;
  if (
    pagination?.page !== page ||
    pagination?.perPage !== perPage ||
    pagination.totalPages !== Math.ceil(data.totalCount / perPage) ||
    pagination.hasMore !== page * perPage < data.totalCount ||
    data.data.length !== Math.min(perPage, Math.max(0, data.totalCount - offset))
  )
    fail();
  const seen = new Set();
  const pageCounts = new Map();
  data.data.forEach((row, index) => {
    if (
      !validCard(row, row?.group) ||
      row.type !== 'TRAVEL' ||
      !totals.has(row.group) ||
      seen.has(row.key) ||
      row.order !== offset + index + 1 ||
      !nullableDate(row.loadingStartedAt) ||
      !nullableDate(row.loadingCompletedAt) ||
      !validPosition(row.lastPosition)
    )
      fail();
    seen.add(row.key);
    const quantity = (pageCounts.get(row.group) || 0) + 1;
    if (quantity > totals.get(row.group)) fail();
    pageCounts.set(row.group, quantity);
  });
  return data;
}

export function formatLastPosition(position) {
  if (!position) return 'Não informado';
  const description = [
    ...new Set([position.information, position.description].filter(Boolean)),
  ].join(' · ');
  const location =
    description ||
    (position.latitude !== null && position.longitude !== null
      ? `Lat ${position.latitude} · Long ${position.longitude}`
      : 'Local não informado');
  const capturedAt = position.capturedAt ? formatDate(position.capturedAt) : 'Data não informada';
  return `${capturedAt} · ${location}`;
}
